export default {
  categories: state => state.categories,
  loaded: state => state.loaded,
  places: state => state.list,
  selected: state => state.selected
};
